<template>
  <div class="container footer-main-container">
    <wrap-container class="footer-main-inner-container">
      <footer>
        <div class="inner-container">
          <div class="logo">
            <img src="@/assets/img/logo.svg" alt="BBVA" />
          </div>
          <wrap-container class="social-container">
            <facebook-image></facebook-image>
            <instagram-image></instagram-image>
            <twitter-image></twitter-image>
            <you-tube-image></you-tube-image>
            <go-image></go-image>
          </wrap-container>
        </div>
        <wrap-container class="link-container small">
          <a
            target="_blank"
            href="https://www.bbva.com.ar/meta/aviso-legal/aviso-legal/"
            >Aviso Legal</a
          >
          <a
            target="_blank"
            href="https://www.bbva.com.ar/meta/aviso-navegadores/aviso-sobre-navegadores/"
            >Aviso Navegadores</a
          >
          <a target="_blank" href="https://www.bbva.com.ar/meta/mapa/">Mapa</a>
          <a target="_blank" href="https://www.bbva.com.ar/empresas.html"
            >Web Corporativa BBVA</a
          >
        </wrap-container>
        <wrap-container class="copyright">
          <p>© {{ anio }} BBVA.</p>
          <a
            target="_blank"
            href="https://www.bbva.com.ar/empresas.html"
            class="oportunity"
            >Creando Oportunidades</a
          >
        </wrap-container>
      </footer>
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import FacebookImage from "@/components/core/FacebookImage";
import InstagramImage from "@/components/core/InstagramImage";
import TwitterImage from "@/components/core/TwitterImage";
import YouTubeImage from "@/components/core/YouTubeImage";
import GoImage from "@/components/core/GoImage";

export default {
  name: "AppFooter",
  components: {
    WrapContainer,
    FacebookImage,
    InstagramImage,
    TwitterImage,
    YouTubeImage,
    GoImage
  },
  computed: {
    anio() {
      const date = new Date();
      return date.getFullYear();
    }
  }
};
</script>

<style scoped>
.footer-main-container {
  background: #072146;
  color: #e4e4e4;
  font-size: 12px;
  line-height: 1.5em;
  margin-left: -17px;
  margin-right: -17px;
  text-align: justify;
  margin-bottom: 0px;
  padding: 60px 0;
}

div.footer-main-inner-container {
  padding-left: 17px;
  padding-right: 17px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

div.inner-container,
.copyright {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
}

div.logo img {
  height: 23px;
}

.link-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.link-container a {
  display: block;
  padding: 20px 0;
  padding-right: 30px;
  text-decoration: none;
  color: #5bbeff;
  font-size: 17px;
}

.link-container a:hover {
  color: white;
  transition: all 0.2s ease-out;
}

.social-container a {
  padding: 8px;
}

p {
  margin-top: 16px;
}

.oportunity {
  text-decoration: none;
  color: #d3d3d3;
  font-size: 17px;
}

.inner-container {
  padding-bottom: 20px;
}

.social-container img:before {
  color: #d3d3d3;
  content: "\e975";
}

@media screen and (max-width: 600px) {
  div.inner-container {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
  }

  div.copyright {
    flex-direction: column;
  }

  .link-container a {
    padding-right: 0;
  }

  .logo {
    margin-bottom: 40px;
  }

  .small {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    flex-flow: column;
    align-items: center;
  }
}
</style>
